import { Modal, Typography } from "antd";
import dayjs from "dayjs";
import React from "react";

function NotificationDetail({ detailModal, selectedNotification, handleClose }) {

    return (
        <>
            <Modal
                open={detailModal}
                title={<Typography.Title level={4} style={{ paddingRight: 20 }}>{selectedNotification?.subject}</Typography.Title>}
                onCancel={handleClose}
                centered
                footer={null}
            >
                <p style={{ fontSize: 18 }}> {selectedNotification?.message}</p>
                <p style={{ color: "lightgray" }}>{dayjs(selectedNotification?.created_at).format("MMM D, YYYY h:mm A")}</p>
            </Modal>
        </>
    )
}

export default NotificationDetail;